enum ErrorTypeEnum {
  wrongCredentials = 'error_wrong_credentials',
  emailNotVerifed = 'error_email_is_not_verified',
}

export default ErrorTypeEnum;
